import { render, staticRenderFns } from "./SettingSwitch.vue?vue&type=template&id=56965bfd&scoped=true&"
import script from "./SettingSwitch.vue?vue&type=script&lang=js&"
export * from "./SettingSwitch.vue?vue&type=script&lang=js&"
import style0 from "./SettingSwitch.vue?vue&type=style&index=0&id=56965bfd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56965bfd",
  null
  
)

export default component.exports